import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { useDispatch } from "react-redux";
import { deleteCookies } from "sr/helpers/functions/deleteCookies";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { setAccessTokenMe } from "sr/helpers/functions/setAccessTokenMe";
import { getRegionId, setRegionIdMe } from "sr/helpers/functions/setCityMe";
import { getUserFullProfile } from "sr/utils/api/user/user";
type AuthContextProps = {
  persistToken: (
    accessToken?: string,
    onBoardingStatus?: boolean
  ) => void;
  setOnboardingStatus: (onBoardingStatus: boolean) => void;
  logout: () => void;
  isAuthReady: boolean;
  isAuthenticate: boolean;
  userType: string;
  accessToken: string;
  onBoardingStatus?: boolean;
};
type WithChildren = {
  children?: ReactNode;
};
const initAuthContextPropsState = {
  persistToken: (
    accessToken?: string,
    onBoardingStatus?: boolean
  ) => {},
  setOnboardingStatus: (onBoardingStatus: boolean) => {},
  logout: () => {},
  isAuthReady: false,
  isAuthenticate: false,
  userType: "",
  accessToken: "",
};
// // create auth context
const AuthContext = createContext<AuthContextProps>(initAuthContextPropsState);
// // use auth context
const useAuth = () => {
  return useContext(AuthContext);
};

// // provider auth context
const AuthProvider = ({ children }: WithChildren) => {
  const [isAuthenticate, setIsAuthenticate] = useState<boolean>();
  const [isAuthReady, setIsAuthReady] = useState<boolean>();
  const [userType, setUserType] = useState<string>();
  const [accessToken, setAccessToken] = useState("");
  const [onBoardingStatus, setOnboardingStatusState] = useState<boolean>();
  const dispatch = useDispatch();

  const logout = async () => {
    setIsAuthReady(false);
    deleteCookies("refreshToken");
    localStorage.removeItem("auth");
    setAccessTokenMe(null);
    setRegionIdMe(null);
    dispatch({ type: "RESET_STATE" });
    setAccessToken("");
    setUserType("");
    setOnboardingStatusState(undefined);
    setIsAuthReady(true);
    setIsAuthenticate(false);
  };
  const setOnboardingStatus = useCallback((onBoardingStatus: boolean) => {
    const userdetails = getUserDetails();
    setOnboardingStatusState(onBoardingStatus);
    if (userdetails?.user_id) {
      localStorage.setItem(
        "auth",
        JSON.stringify({
          ...userdetails,
          onBoardingStatus,
        })
      );
    }
  }, []);

  const persistToken = useCallback((
    accessToken?: any,
    onBoardingStatus?: boolean
  ) => {
    setIsAuthReady(false);
    const userdetails = getUserDetails();
    if (userdetails?.user_id) {
      console.log("userdetails?.user_id", userdetails?.user_id);

      const token = accessToken || userdetails?.accessToken;
      const savedOnBoardingStatus =
        typeof onBoardingStatus === "boolean"
          ? onBoardingStatus
          : userdetails?.onBoardingStatus;
      if (token) {
        setAccessToken(token);
        setAccessTokenMe(token);
        localStorage.setItem(
          "auth",
          JSON.stringify({
            ...userdetails,
            accessToken: token,
            onBoardingStatus: savedOnBoardingStatus,
          })
        );
      }
      setIsAuthenticate(true);
      setUserType(userdetails?.userType);
      setOnboardingStatusState(savedOnBoardingStatus);
    } else {
      setIsAuthenticate(false);
    }
    setIsAuthReady(true);
  }, []);
  useEffect(() => {
    persistToken();
  }, [persistToken]);
  useEffect(() => {
    if (
      !isAuthenticate ||
      !accessToken ||
      getRegionId() ||
      (userType !== "cleaner" && userType !== "individual")
    ) {
      return;
    }

    const session = getUserDetails();
    getUserFullProfile().then((response) => {
      const currentSession = getUserDetails();
      if (
        currentSession?.user_id !== session?.user_id ||
        currentSession?.userType !== session?.userType
      ) {
        return;
      }
      const rawRegionId = response?.data?.regions?.[0]?.regionId;
      setRegionIdMe(
        typeof rawRegionId === "object"
          ? rawRegionId?.id || rawRegionId?._id || null
          : rawRegionId || null
      );
    });
  }, [accessToken, isAuthenticate, userType]);

  return (
    <AuthContext.Provider
      value={{
        isAuthenticate,
        isAuthReady,
        logout,
        persistToken,
        setOnboardingStatus,
        userType,
        accessToken,
        onBoardingStatus,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

// provider auth context
const authInit = () => {};

export { useAuth, AuthProvider };
